var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyIcons10 = function SvgSurveyIcons10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "SurveyIcons-10_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 45 45"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SurveyIcons-10_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.13 8.28a4 4 0 0 0-5.46.4l-.58.6-.58-.6a4 4 0 0 0-5.46-.4 4.28 4.28 0 0 0-.29 6.15l5.66 5.91a.91.91 0 0 0 1.33 0l5.66-5.91a4.28 4.28 0 0 0-.28-6.15Z",
    className: "SurveyIcons-10_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SurveyIcons-10_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-120.45-51.91h360.73v846.27h-360.73z",
    className: "SurveyIcons-10_svg__cls-1"
  })), /*#__PURE__*/React.createElement("style", null, ".SurveyIcons-10_svg__cls-1{fill:none}"))), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 11.29h-1.85v14.77a1.85 1.85 0 0 1-1.85 1.85H11.55v1.85a3.7 3.7 0 0 0 3.69 3.69h18.47l7.39 7.39V15a3.7 3.7 0 0 0-3.7-3.71Z",
    style: {
      fill: "#f68b50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86 20.52V7.59a3.7 3.7 0 0 0-3.69-3.69H7.85a3.7 3.7 0 0 0-3.69 3.69v24l7.39-7.39h16.62a3.7 3.7 0 0 0 3.69-3.68Z",
    style: {
      fill: "#4f6b80"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SurveyIcons-10_svg__clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SurveyIcons-10_svg__clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.48 4.25H28.7v19.49H7.48z",
    style: {
      fill: "#fff"
    }
  }))));
};
export default SvgSurveyIcons10;